import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { mapToOptions, Option } from "@sinch/utils/option";
import { propEq } from "ramda";
import React, { useCallback, useMemo } from "react";
import { AutocompleteOptions } from "@sinch/components/form/AutocompleteInput/types";

export interface RateComponentOptionSource {
  id: string;
  name: string;
  description?: string | null;
}

/**
 * Option list and option renderer shared by every autocomplete that picks rate components,
 * so the rate unit settings offer the same name + description rows as the ratelist builder.
 */
export const useRateComponentOptions = (rateComponents: readonly RateComponentOptionSource[] | undefined) => {
  const options = useMemo<Option[]>(() => mapToOptions("id", "name")(rateComponents ?? []), [rateComponents]);

  const renderOption = useCallback(
    (props: React.HTMLAttributes<HTMLLIElement> & { key: any }, option: AutocompleteOptions) => (
      <ListItem {...props} sx={{ textAlign: "initial", width: "auto" }}>
        <ListItemText
          primary={option.label}
          secondary={rateComponents?.find(propEq("id", option.value))?.description}
          slotProps={{
            secondary: {
              sx: {
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                maxWidth: "200px",
                overflow: "hidden",
              },
            },
          }}
          sx={{ m: 0 }}
        />
      </ListItem>
    ),
    [rateComponents]
  );

  return { options, renderOption };
};
